import { __exportAll } from "./_virtual/_rolldown/runtime.js";
//#region src/locale-format.ts
var locale_format_exports = /* @__PURE__ */ __exportAll({
	getCurrentFormatLocale: () => getCurrentFormatLocale,
	getCurrentTimeZone: () => getCurrentTimeZone,
	setCurrentFormatLocale: () => setCurrentFormatLocale
});
var settingsMap = {
	be: {
		locale: "nl-BE",
		timeZone: "Europe/Brussels"
	},
	en: {
		locale: "en-GB",
		timeZone: "Europe/London"
	},
	de: {
		locale: "de-DE",
		timeZone: "Europe/Berlin"
	}
};
var currentLocale = "de-DE";
var currentTimeZone = "Europe/Berlin";
/**
* Gets the current format locale (e.g., "de-DE", "en-GB").
*/
var getCurrentFormatLocale = () => currentLocale;
/**
* Gets the current time zone (e.g., "Europe/Berlin").
*/
var getCurrentTimeZone = () => currentTimeZone;
/**
* Sets the current format locale and time zone based on a locale key.
*
* @param localeKey - Locale key ("de", "en", "be"). Defaults to "de" if unknown.
*/
var setCurrentFormatLocale = (localeKey) => {
	const settings = settingsMap[localeKey] ?? settingsMap["de"];
	currentLocale = settings.locale;
	currentTimeZone = settings.timeZone;
};
//#endregion
export { getCurrentFormatLocale, getCurrentTimeZone, locale_format_exports, setCurrentFormatLocale };
